import { rootApi } from './rootApi';

const buildUrlWithParams = (baseUrl, params) => {
    const queryParts = [];

    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;

        if (Array.isArray(value)) {
            value.forEach(item => {
                if (item != null && item !== '') {
                    queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
                }
            });
        } else {
            queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });

    const queryString = queryParts.join('&');
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const customerDeclarationApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getDeclarations: builder.query({
            query: (params = {}) => {
                const queryParams = {
                    PageNumber: params.PageNumber || 1,
                    PageSize: params.PageSize || 10,
                    LanguageId: params.LanguageId || 1
                };

                if (params.Id) {
                    queryParams.Id = params.Id;
                }

                if (params.ChassisNo) {
                    queryParams.ChassisNo = params.ChassisNo;
                }

                if (params.LicensePlate) {
                    queryParams.LicensePlate = params.LicensePlate;
                }

                if (params.DealerId) {
                    queryParams.DealerId = params.DealerId;
                }

                if (params.Country) {
                    queryParams.Country = params.Country;
                }

                if (params.CustomerId) {
                    queryParams.CustomerId = params.CustomerId;
                }

                if (params.Status) {
                    queryParams.Status = params.Status;
                }

                if (params.StartDate) {
                    queryParams.StartDate = params.StartDate;
                }

                if (params.EndDate) {
                    queryParams.EndDate = params.EndDate;
                }

                if (params.IsInvoiced) {
                    queryParams.IsInvoiced = params.IsInvoiced;
                }

                const finalUrl = buildUrlWithParams('v1/customerstatement/getcustomerstatement', queryParams);


                return {
                    url: finalUrl,
                    method: 'GET'
                };
            },
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data?.items) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount,
                        count: response.count
                    };
                }
                return { items: [], totalCount: 0, count: 0 };
            },
            providesTags: ['CustomerDeclarationList']
        }),
        getDeclarationById: builder.query({
            query: (id) => ({
                url: 'v1/customerstatement/getcustomerstatementbyid',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'Veri bulunamadı');
            },
            providesTags: (result, error, id) => [{ type: 'CustomerDeclarationDetail', id }]
        }),
        getDeclarationReportById: builder.query({
            query: (id) => ({
                url: 'v1/customerstatement/getcustomerstatementreportbyid',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'Veri bulunamadı');
            },
            providesTags: (result, error, id) => [{ type: 'CustomerDeclarationDetail', id }]
        }),
        addDeclaration: builder.mutation({
            query: (formData) => ({
                url: 'v1/customerstatement/create',
                method: 'POST',
                body: {
                    vehicleAcceptDate: formData.serviceDeliveryDate || null,
                    chassisNo: formData.chassisNumber || '',
                    customer: formData.customerId || 0,
                    customerPhone: formData.customerPhone || '',
                    customerStatement: formData.declaration || '',
                    kmInformation: formData.kilometer || 0,
                    licensePlate: formData.plateNumber || '',
                    brand: String(formData.brand || ''),
                    model: String(formData.model || ''),
                    dateOfTraffic: formData.registrationDate || null,
                    receivingDeliveryPerson: formData.receivedBy || '',
                    deliveryPhone: formData.deliveryPhone || '',
                    receivingPerson: formData.deliveredBy || '',
                    bosBranchCode: String(formData.dealerId || ''),
                    bosBranchSiteCode: String(formData.siteUseId || ''),
                    serviceNote: formData.serviceNote || ''
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || response?.message || 'Kayıt işlemi başarısız');
            },
            invalidatesTags: ['CustomerDeclarationList']
        }),
        updateDeclaration: builder.mutation({
            query: ({ id, formData }) => ({
                url: 'v1/customerstatement/update',
                method: 'POST',
                body: {
                    id: id,
                    vehicleAcceptDate: formData.serviceDeliveryDate || null,
                    chassisNo: formData.chassisNumber || '',
                    customer: formData.customerId || 0,
                    customerPhone: formData.customerPhone || '',
                    customerStatement: formData.declaration || '',
                    kmInformation: formData.kilometer || 0,
                    licensePlate: formData.plateNumber || '',
                    brand: String(formData.brand || ''),
                    model: String(formData.model || ''),
                    dateOfTraffic: formData.registrationDate || null,
                    receivingDeliveryPerson: formData.receivedBy || '',
                    receivingPerson: formData.deliveredBy || '',
                    deliveryPhone: formData.deliveryPhone || '',
                    serviceNote: formData.serviceNote || ''
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || response?.message || 'Güncelleme işlemi başarısız');
            },
            invalidatesTags: (result, error, { id }) => ['CustomerDeclarationList', { type: 'CustomerDeclarationDetail', id }]
        }),
        deleteDeclaration: builder.mutation({
            query: (id) => ({
                url: 'v1/customerstatement/delete',
                method: 'POST',
                body: { id: id }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || response?.message || 'Silme işlemi başarısız');
            },
            invalidatesTags: ['CustomerDeclarationList']
        }),
        closeDeclaration: builder.mutation({
            query: ({ id, description }) => ({
                url: 'v1/customerstatement/close',
                method: 'POST',
                body: {
                    Id: id,
                    Description: description
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || response?.message || 'Form kapatma işlemi başarısız');
            },
            invalidatesTags: (result, error, { id }) => ['CustomerDeclarationList', { type: 'CustomerDeclarationDetail', id }]
        }),
        getCustomerStatementHistory: builder.query({
            query: ({ id, pageNumber = 0, pageSize = 100 }) => ({
                url: 'v1/customerstatement/gethistorybyid',
                method: 'POST',
                body: { id, pageNumber, pageSize }
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && response.data.data && Array.isArray(response.data.data.items)) {
                        return response.data.data.items;
                    }
                    if (response.data && Array.isArray(response.data.items)) {
                        return response.data.items;
                    }
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }
                    if (Array.isArray(response)) {
                        return response;
                    }
                }
                return [];
            }
        }),
        getChassisDetail: builder.query({
            query: ({ chassisNumber, kmInformation, vehicleDate } = {}) => ({
                url: 'v1/customerstatement/getchassisdetail',
                method: 'GET',
                params: {
                    ChassisNumber: String(chassisNumber || '').trim(),
                    kmInformation: kmInformation || 0,
                    vehicleDate: vehicleDate || null
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                return {
                    chassisNumber: '',
                    chassisDescription: null,
                    brand: null,
                    model: null,
                    plateNumber: null,
                    registrationDate: null,
                    lastKmInfo: null,
                    customerId: null,
                    customerPhone: null
                };
            },
            providesTags: ['CustomerDeclarationDetail']
        }),
        markOpenDocumentPrinted: builder.mutation({
            query: (id) => ({
                url: 'v1/customerstatement/markopendocumentprinted',
                method: 'POST',
                body: { id: id }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || response?.message || 'İşlem başarısız');
            },
            invalidatesTags: ['CustomerDeclarationList']
        }),
        exportToExcel: builder.query({
            query: (params = {}) => {
                const queryParams = {};

                if (params.Id) {
                    queryParams.Id = params.Id;
                }
                if (params.ChassisNo) {
                    queryParams.ChassisNo = params.ChassisNo;
                }
                if (params.LicensePlate) {
                    queryParams.LicensePlate = params.LicensePlate;
                }
                if (params.DealerId) {
                    queryParams.DealerId = params.DealerId;
                }
                if (params.CustomerId) {
                    queryParams.CustomerId = params.CustomerId;
                }
                if (params.Status) {
                    queryParams.Status = params.Status;
                }
                if (params.StartDate) {
                    queryParams.StartDate = params.StartDate;
                }
                if (params.EndDate) {
                    queryParams.EndDate = params.EndDate;
                }

                return {
                    url: 'v1/customerstatement/exporttoexcel',
                    method: 'GET',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const data = response.data;
                    return {
                        fileBase64: data.fileBase64,
                        fileName: data.fileName,
                        contentType: data.contentType,
                        recordCount: data.recordCount,
                        fileSize: data.fileSize,
                        isCompressed: data.isCompressed
                    };
                }
                throw new Error(response?.errorMessage || 'Excel oluşturulurken bir hata oluştu.');
            }
        }),
        uploadRepairDocument: builder.mutation({
            query: (formData) => ({
                url: 'v1/customerstatement/uploaddocument',
                method: 'POST',
                body: formData
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || response?.message || 'Dosya yükleme işlemi başarısız');
            },
            invalidatesTags: ['CustomerDeclaration']
        }),
        getRepairDocumentsById: builder.query({
            query: (id) => ({
                url: 'v1/customerstatement/getdocumentsbyid',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'Dokümanlar bulunamadı');
            },
            providesTags: (result, error, id) => [{ type: 'CustomerStatementDocuments', id }]
        }),
        getWarrantClaimsForRepairClose: builder.query({
            query: ({ customerStatementId, languageId }) => ({
                url: 'v1/repairclose/getwarrantclaimsforrepairclose',
                method: 'GET',
                params: { customerStatementId, languageId }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'Veri bulunamadı');
            }
        }),
        upsertRepairCloseInvoice: builder.mutation({
            query: (data) => ({
                url: 'v1/repairclose/upsertrepaircloseinvoice',
                method: 'POST',
                body: data
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'Kayıt işlemi başarısız');
            },
            invalidatesTags: ['CustomerDeclarationList']
        }),
        getCustomerDiscountRates: builder.query({
            query: (customerId) => ({
                url: 'v1/repairclose/getcustomerdiscountrates',
                method: 'GET',
                params: { customerId }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'Veri bulunamadı');
            }
        }),
        repairClosingToAccounting: builder.mutation({
            query: (statmentId) => ({
                url: 'v1/repairclose/repairclosingtoaccounting',
                method: 'POST',
                body: { statmentId }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'İşlem başarısız');
            },
            invalidatesTags: ['CustomerDeclarationList']
        }),
        undoRepairCloseAccounting: builder.mutation({
            query: (id) => ({
                url: 'v1/repairclose/undoaccounting',
                method: 'POST',
                body: { id }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) {
                    return response.data;
                }
                throw new Error(response?.errorMessage || 'İşlem başarısız');
            },
            invalidatesTags: ['CustomerDeclarationList']
        }),
        deleteRepairDocument: builder.mutation({
            query: ({ formId, documentId }) => ({
                url: 'v1/customerstatement/deletedocument',
                method: 'DELETE',
                body: {
                    FormId: formId,
                    DocumentId: documentId
                }
            }),
            transformResponse: (response) => {
                return response?.data ?? response;
            },
            invalidatesTags: ['CustomerStatementDocuments']
        }),
        getDraftWarrantyClaims: builder.query({
            query: (id) => ({
                url: 'v1/customerstatement/getdraftwarrantyclaims',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                if (response?.success && response?.data) {
                    return {
                        items: response.data.items || [],
                        totalCount: response.data.totalCount || 0
                    };
                }
                if (response?.isSuccessful && response?.data) {
                    return {
                        items: response.data.items || [],
                        totalCount: response.data.totalCount || 0
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: (result, error, id) => [{ type: 'DraftWarrantyClaims', id }]
        })
    })
});

export const {
    useGetDeclarationsQuery,
    useLazyGetDeclarationsQuery,
    useGetDeclarationByIdQuery,
    useLazyGetDeclarationByIdQuery,
    useGetDeclarationReportByIdQuery,
    useLazyGetDeclarationReportByIdQuery,
    useAddDeclarationMutation,
    useUpdateDeclarationMutation,
    useDeleteDeclarationMutation,
    useCloseDeclarationMutation,
    useGetCustomerStatementHistoryQuery,
    useLazyGetChassisDetailQuery,
    useGetChassisDetailQuery,
    useMarkOpenDocumentPrintedMutation,
    useLazyExportToExcelQuery,
    useUploadRepairDocumentMutation,
    useGetRepairDocumentsByIdQuery,
    useLazyGetRepairDocumentsByIdQuery,
    useLazyGetWarrantClaimsForRepairCloseQuery,
    useUpsertRepairCloseInvoiceMutation,
    useLazyGetCustomerDiscountRatesQuery,
    useRepairClosingToAccountingMutation,
    useUndoRepairCloseAccountingMutation,
    useDeleteRepairDocumentMutation,
    useGetDraftWarrantyClaimsQuery,
    useLazyGetDraftWarrantyClaimsQuery
} = customerDeclarationApi;